module.exports = "swiper { \r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.swiper-container {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.swiper-wrapper {\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n}\r\n\r\n.swiper-slide {\r\n max-width: 300px;\r\n width: 100%;\r\n}\r\n\r\n.swiper-slide:last-child {\r\n  margin-right: calc(100% - (100% / 3));\r\n}\r\n\r\n.swiper-pagination {\r\n\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/product-category/containers/carousel/carousel.component.css
// module id = ./src/app/product-category/containers/carousel/carousel.component.css
// module chunks = main